import { render, staticRenderFns } from "./NewWebHook.vue?vue&type=template&id=5264b4c4&"
import script from "./NewWebHook.vue?vue&type=script&lang=js&"
export * from "./NewWebHook.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports